import { css } from "styled-components";
export const boxShadow100 = css `
  box-shadow:
    0 2px 3px rgba(103, 132, 162, 0.08),
    0 1px 8px rgba(103, 132, 162, 0.16);
`;
export const boxShadow200 = css `
  box-shadow:
    0 1px 4px rgba(103, 132, 162, 0.16),
    0 4px 16px -2px rgba(103, 132, 162, 0.32);
`;
export const boxShadow400 = css `
  box-shadow:
    0 1px 6px rgba(103, 132, 162, 0.24),
    0 4px 24px -4px rgba(103, 132, 162, 0.4);
`;
export const boxSelectionGlow = css `
  box-shadow: 0 0 7px 0 rgba(10, 109, 230, 0.2);
`;
